<template>

  <component :is="el" :label="label" :required="required">

    <el-cascader
        v-model="form"
        placeholder="Select Locality..."
        :options="locality.regions"
        :disabled="disabled"
        :props="{label: 'name', value: 'name', children: 'divisions'}"
        :size="size"
        :show-all-levels="showLevels"
        filterable
        @change="updated">
  </el-cascader>

</component>
</template>

<script>

import {localityData} from '@/components/Data'

export default {
  name: 'select-locality',

  props: {
    label: {
      type: String,
      default: 'Locality'
    },
    value: {
//      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'default'
    },
    placeholder: {
      type: String,
      default: null
    },
    helpText: {
      type: String,
      default: null
    },
    showLevels: {
      type: Boolean,
      default: true
    },
    noForm: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    },

    formatValue () {
      return this.form
    }
  },

  data () {
    return {
      el: this.noForm ? 'div' : 'el-form-item',
      form: this.removeNullArray(this.value),
      locality: localityData
    }
  }
}
</script>

<style scoped>
.el-cascader {display: inline-block; width: 100%;}
</style>



// WEBPACK FOOTER //
// SelectLocality.vue?40b2500c